/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AnnotationsRegion16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M11 9.878c0 2.142-1.844 3.878-4.017 3.878H5.96l-2.23 1.205c-.252.106-.762-.008-.87-.257a.48.48 0 01-.04-.19l-.001-1.557C1.91 12.245 1 11.107 1 9.878 1 7.736 2.76 6 4.934 6h2.05C9.156 6 11 7.736 11 9.878zM6 8c-.17 0-.312.14-.312.303V9.7H4.3a.32.32 0 00-.3.3c0 .17.15.3.3.3h1.377v1.387c0 .16.142.303.312.303s.314-.145.314-.303V10.3H7.7c.165 0 .3-.14.3-.3s-.144-.3-.3-.3H6.313V8.303A.313.313 0 006 8zm8.997-4.72l.003.15v3.533a2.42 2.42 0 01-2.26 2.425l-.147.004h-.254a.663.663 0 01-.09-1.318l.344-.006c.566 0 1.032-.434 1.088-.99l.006-.113V3.43a1.1 1.1 0 00-.982-1.098l-.112-.006H6.25c-.566 0-1.032.434-1.088.99l-.006.113v1.22a.66.66 0 01-.656.662.66.66 0 01-.65-.573l-.006-.1V3.43a2.42 2.42 0 012.26-2.425L6.25 1h6.344a2.416 2.416 0 012.402 2.28z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default AnnotationsRegion16;
